import 'date-fns';
import koLocale from 'date-fns/locale/ko';
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {
    Button,
    Card,
    CardContent,
    Grid,
    FormControl,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

const useStyles = makeStyles((theme) => ({
    root: {},
    formControl: {
        marginRight: theme.spacing(1),
    },
    select: {},
    icon: {
        marginRight: '12px',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));



const SingleCalendar = props => {
    const {className, date_option, onSubmit, ...rest} = props;
    const classes = useStyles(props);

    const getDigit = num => num < 10 ? `0${num}` : num.toString();
    const getFullDate = (date, format = 'yyyy/MM/dd') => {
        const year = date.getFullYear();
        const month = getDigit(date.getMonth()+1);
        const dt = getDigit(date.getDate());

        return format === 'yyyy/MM/dd' ? `${year}-${month}-${dt}` : `${year}-${month}`;
    };

    // 기준 일 선택
    const [standardDate, setStandardDate] = React.useState(getFullDate(date_option.date, date_option.format));
    const handleStandardDateChange = date => {
        setStandardDate(getFullDate(date, date_option.format));
    };

    function enableMonday(date) {
        return date.getDay() === 0 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 ||
            date.getDay() === 5 || date.getDay() === 6;
    }

    const submitHandler = (e) => {
        e.preventDefault();

        onSubmit({targetDate: standardDate});
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    alignItems="flex-end"
                    container
                    spacing={2}
                >
                    <Grid
                        item
                        md={10}
                        sm={10}
                        xs={12}
                    >
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                        >
                            <MuiPickersUtilsProvider
                                locale={koLocale}
                                utils={DateFnsUtils}
                            >
                                <KeyboardDatePicker
                                    autoOk
                                    disableFuture
                                    disableToolbar
                                    format={date_option.format}
                                    id="standard_date"
                                    label={date_option.label}
                                    maxDate={date_option.date}
                                    onChange={handleStandardDateChange}
                                    openTo={date_option.openTo}
                                    orientation="portrait"
                                    value={standardDate}
                                    variant="inline"
                                    views={date_option.views}
                                    shouldDisableDate={(date_option.enableMonday ? enableMonday : null)}
                                />
                            </MuiPickersUtilsProvider>
                        </FormControl>
                    </Grid>
                    <Grid
                        item
                        md={2}
                        sm={2}
                        xs={12}
                    >
                        <Button
                            color="primary"
                            fullWidth
                            onClick={submitHandler}
                            size="small"
                            variant="outlined"
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

SingleCalendar.propTypes = {
    className: PropTypes.string,
    date_option: PropTypes.object,
    onSubmit: PropTypes.func,
    report: PropTypes.string
};

export default SingleCalendar;
